export default __webpack_public_path__ + "cc64a0cb745857d161df4fd50a56ba72.png";